import { render, staticRenderFns } from "./LangRow.vue?vue&type=template&id=0b0052e8&scoped=true&"
import script from "./LangRow.vue?vue&type=script&lang=js&"
export * from "./LangRow.vue?vue&type=script&lang=js&"
import style0 from "./LangRow.vue?vue&type=style&index=0&id=0b0052e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0052e8",
  null
  
)

export default component.exports